import {EnvConfig} from "../../../Shared/Constants/environtmentConstants";
import {ExternalLeadType} from "../type/externalLeadType";

export const SaveExternalLeadUnicContactHook = async (formData : ExternalLeadType): Promise<Response> => {
    return await fetch(
        EnvConfig().winahost_api_url + '/external-lead/create', {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
}